import * as React from "react";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Breadcrumbs from "@mui/material/Breadcrumbs";

import { Link as RouterLink, useLocation } from "react-router-dom";

function LinkRouter(props) {
  return <Link {...props} component={RouterLink} />;
}

const BreadCrumbs = () => {
  const breadcrumbNameMap = {
    "/product-view": "Products",
    "/inbox/important": "Important",
    "/category-view": "category-view",
    "/account": "My Account",
    "/account/profile": "Profile",
    "/account/notification": "Notification",
    "/account/mamapurse": "Mamapurse",
    "/account/orders": "My Orders",
    "/account/security": "Security",
    "/account/referral": "Referral",
    "/account/help-center": "Help Center",
    "/account/address": "Address",
    "/account/orders/order-details/product": "product",
    "/account/orders/order-details/service": "service",
    "/account/orders/order-details": "order-details",
  };
  const location = useLocation();
  let pathnames = location.pathname.split("/").filter((x) => x);

  return (
    <>
      <Box
        className="hide_scrollbar"
        sx={{
          p: 1,
          bgcolor: "#fff",
          overflow: "scroll",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Breadcrumbs
          aria-label="breadcrumb"
          separator={<NavigateNextIcon fontSize="small" />}
        >
          <LinkRouter
            underline="hover"
            color="inherit"
            to="/my-account"
            style={{ fontSize: "12px", fontWeight: 600 }}
          >
            Home
          </LinkRouter>
          {pathnames.map((value, index) => {
            const last = index === pathnames.length - 1;
            const to = `/${pathnames.slice(0, index + 1).join("/")}`;

            return (
              <LinkRouter
                underline="hover"
                color="inherit"
                to={to}
                key={to}
                sx={{ fontSize: "12px", fontWeight: 600 }}
              >
                {breadcrumbNameMap[to]}
              </LinkRouter>
            );
          })}
        </Breadcrumbs>
      </Box>
    </>
  );
};

export default BreadCrumbs;
